import axiosClient from "../../../helpers/axios-client";
import { CLOSE_FORM_LOADING, FORM_SUBMISSION_STATUS } from "../../common/actionTypes";
import { CREATE_ADDON_CATEGORIES_URL, CREATE_ADDON_URL, DELETE_ADDON_CATEGORIES_URL, DELETE_ADDON_URL, GET_ALL_ADDON_CATEGORIES_URL, GET_ALL_ADDON_URL, TOGGLE_ADDON_CATEGORIES_URL, TOGGLE_ADDON_URL, UPDATE_ADDON_CATEGORIES_URL, UPDATE_ADDON_URL } from "../../../config";
import { GET_ALL_ADDON, GET_ALL_ADDON_CATEGORY } from './actionType';



// addon Categories

export const getAllAddonCategory = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_ADDON_CATEGORIES_URL)
        .then((response) => {

            if (response && response.data.success) {
                const category = response.data.data;
                return dispatch({ type: GET_ALL_ADDON_CATEGORY, payload: category });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};


export const toggleAddonCategory = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_ADDON_CATEGORIES_URL, {
        id,
    });
};

export const createAddonCategory = (data) => (dispatch) => {
    return axiosClient.post(CREATE_ADDON_CATEGORIES_URL, data,)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        }).catch(error => {
            console.log(error);
        });
};

export const updateAddonCategory = (data, id) => (dispatch) => {
    return axiosClient.post(UPDATE_ADDON_CATEGORIES_URL, { data, id })
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        }).catch(error => {
            console.log(error);
        });
};

export const deleteAddonCategory = (id) => (dispatch) => {
    return axiosClient.post(DELETE_ADDON_CATEGORIES_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};

// addon categories end

// addons

export const getAllAddons = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_ADDON_URL)
        .then((response) => {

            if (response && response.data.success) {
                const addons = response.data.data;
                return dispatch({ type: GET_ALL_ADDON, payload: addons });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const toggleAddon = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_ADDON_URL, {
        id,
    });
};

export const createAddon = (data) => (dispatch) => {
    return axiosClient.post(CREATE_ADDON_URL, data,)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        }).catch(error => {
            console.log(error);
        });
};

export const updateAddon = (data, id) => (dispatch) => {
    return axiosClient.post(UPDATE_ADDON_URL, { data, id })
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        }).catch(error => {
            console.log(error);
        });
};

export const deleteAddon = (id) => (dispatch) => {
    return axiosClient.post(DELETE_ADDON_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};
